<template>
  <b-container class="text-center">
    <b-row align-h="center" class="mb-5">
      <b-col cols="10" md="6">
        <b-form-group 
          :label="formConfig.reference.label" 
          label-class="h5"
          :label-for="formConfig.reference.id"
          :state="stateReference"
          v-slot="{ ariaDescribedBy }"
          :validated="formSubmitted"
        >
          <b-form-radio-group buttons button-variant="outline-dark" stacked
            class="d-flex flex-column align-items-start mt-3"
            :aria-describedby="ariaDescribedBy"
            :id="formConfig.reference.id"
            :name="formConfig.reference.name"
            v-model.trim="formData.reference"
            :state="stateReference"
          >
            <b-form-radio class="btb-radio-button"
              v-for="{ text, value } in formConfig.reference.options"
              :key="value"
              :value="value"
            >
              {{ text }}
            </b-form-radio>
          </b-form-radio-group>

          <!-- TODO: break into separate component -->
          <b-form-group class="mt-3" v-if="formData.reference === optionOther.value">
            <span class="btb-form-description">Please provide response with minimum 5 characters</span>
            <b-textarea class="flex-grow-1"
              v-bind="formConfig.reference"
              v-model.trim="formData.other"
            />
          </b-form-group>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { GET_SURVEY_OPTIONS } from '@/store/getters'
import { UPDATE_HEARD_FROM } from '@/store/mutations'
import { isOptionOther } from '@/utils'
import { SURVEYS, SURVEY_ID } from '@/store/state'
import { validateBeforeRouteLeave } from '@/utils/mixins/validateBeforeRouteLeave'

export const PROMOTION_EVENTS = {
  COMPLETED: 'PromotionStep:Completed'
}

const FALLBACK_SURVEY_DATA = [ // NOTE: ids are from the DB
  {
    text: "Heard about it directly from a friend, family or colleague",
    value: 2,
  },
  {
    text: "Saw it on a friend's social media",
    value: 3,
  },
  {
    text: "Google search",
    value: 4,
  },
  {
    text: "Trip Advisor, Yelp or other Review site",
    value: 5,
  },
  {
    text: "Instagram",
    value: 7,
  },
  {
    text: "TikTok",
    value: 8,
  },
  {
    text: "Other",
    value: 6,
  },
]

export default {
  name: 'Promotion',
  mixins: [
    validateBeforeRouteLeave
  ],
  props: {
    heardFrom: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      formData: {
        reference: this.heardFrom.id ?? null,
        other: this.heardFrom.detail ?? null
      },
      formSubmitted: false
    }
  },
  computed: {
    ...mapState([
      SURVEYS,
      SURVEY_ID
    ]),
    ...mapGetters([
      GET_SURVEY_OPTIONS
    ]),
    optionOther () {
      return this.formConfig.reference.options.find(({ text }) => isOptionOther(text))
    },
    canProceed () {
      const { reference, other } = this.formData;

      return (
        (reference === this.optionOther?.value)
          ? other?.length
          : !!reference
      )
    },
    formConfig () {
      const surveyId = this[SURVEY_ID]
      const surveyConfig = this[GET_SURVEY_OPTIONS][surveyId]

      return {
        reference: {
          id: 'promotion-reference',
          label: surveyConfig.label,
          name: 'reference',
          options: surveyConfig.options ?? FALLBACK_SURVEY_DATA,
          rows: '3',
          maxRows: '5',
        }
      }
    },
    stateReference () {
      return this.formSubmitted ? this.canProceed : null
    }
  },
  mounted () {
    if (this.canProceed) this.completeStep(true)
  },
  watch: {
    canProceed (fresh) {
      this.completeStep(fresh)
    }
  },
  methods: {
    completeStep (isComplete) {
      this.$emit(PROMOTION_EVENTS.COMPLETED, isComplete ? this : null);
    },
    validateForm () {
      this.formSubmitted = true
      return this.canProceed
    },
    updateHeardFrom () {
      try {
        this.$store.commit(UPDATE_HEARD_FROM, {
          id: this.formData.reference,
          detail: this.formData.other
        })
      } catch (err) {
        console.error(`There was an error updating the Heard About Us details`)
        console.error(err)
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.updateHeardFrom()
    if (to.name === 'Guardian') {
      const isValid = this.validateForm()
      return next(isValid)
    }

    return next()
  }
}
</script>

<style lang="scss" scoped>

</style>